// extracted by mini-css-extract-plugin
module.exports = {"footer":"Footer_footer__bXVCd","buttonWrapper":"Footer_buttonWrapper__yhIir"};